import React from 'react'
import GalleryGridContainer from '../../../../Components/Miscellaneous/Gallery/GalleryGrid'

export default function GalleryGrid() {
  return (
    <div className='page-body'>
        <GalleryGridContainer/>
    </div>
  )
}
